import { Action } from '@ngrx/store';
import firebase from 'firebase/compat/app';

export enum ActionType {

  ADD_COMPANYSITEUSERLOCATION = 'ADD COMPANYSITEUSERLOCATION',
  ADD_COMPANYSITEUSERLOCATION_SUCCESS = 'ADD COMPANYSITEUSERLOCATION SUCCESS',
  ADD_COMPANYSITEUSERLOCATION_FAILED = 'ADD COMPANYSITEUSERLOCATION FAILED',

  ADD_COMPANYUSERLOCATION = 'ADD COMPANYUSERLOCATION',
  ADD_COMPANYUSERLOCATION_SUCCESS = 'ADD COMPANYUSERLOCATION SUCCESS',
  ADD_COMPANYUSERLOCATION_FAILED = 'ADD COMPANYUSERLOCATION FAILED',

  ADD_SITEUSERLOCATION = 'ADD SITEUSERLOCATION',
  ADD_SITEUSERLOCATION_SUCCESS = 'ADD SITEUSERLOCATION SUCCESS',
  ADD_SITEUSERLOCATION_FAILED = 'ADD SITEUSERLOCATION FAILED',

  ADD_COMPANYSITECATEGORYPRODUCTGROUPPRODUCT = 'ADD COMPANYSITEUSERCATEGORYPRODUCTGROUPPRODUCT',
  ADD_COMPANYSITECATEGORYPRODUCTGROUPPRODUCT_SUCCESS = 'ADD COMPANYSITEUSERCATEGORYPRODUCTGROUPPRODUCT SUCCESS',
  ADD_COMPANYSITECATEGORYPRODUCTGROUPPRODUCT_FAILED = 'ADD COMPANYSITEUSERCATEGORYPRODUCTGROUPPRODUCT FAILED',

  ADD_SITEUSER = 'ADD SITEUSER',
  ADD_SITEUSER_SUCCESS = 'ADD SITEUSER SUCCESS',
  ADD_SITEUSER_FAILED = 'ADD SITEUSER FAILED',

  ADD_SITEUSERHOTELROOMNUMBER = 'ADD SITEUSERHOTELROOMNUMBER',
  ADD_SITEUSERHOTELROOMNUMBER_SUCCESS = 'ADD SITEUSERHOTELROOMNUMBER SUCCESS',
  ADD_SITEUSERHOTELROOMNUMBER_FAILED = 'ADD SITEUSERHOTELROOMNUMBER FAILED',

}

export class AddSiteUserHotelRoomNumber implements Action {
  readonly type = ActionType.ADD_SITEUSERHOTELROOMNUMBER;
  constructor(public roomNumber: number) { }
}

export class AddSiteUserHotelRoomNumberSuccess implements Action {
  readonly type = ActionType.ADD_SITEUSERHOTELROOMNUMBER_SUCCESS;
  constructor() { }
}

export class AddSiteUserHotelRoomNumberFailed implements Action {
  readonly type = ActionType.ADD_SITEUSERHOTELROOMNUMBER_FAILED;
  constructor() { }
}

export class AddSiteUser implements Action {
  readonly type = ActionType.ADD_SITEUSER;

  constructor(public user: firebase.User) { }
}

export class AddSiteUserSuccess implements Action {
  readonly type = ActionType.ADD_SITEUSER_SUCCESS;
  constructor() { }
}

export class AddSiteUserFailed implements Action {
  readonly type = ActionType.ADD_SITEUSER_FAILED;
  constructor() { }
}

export class AddCompanySiteUserLocation implements Action {
  readonly type = ActionType.ADD_COMPANYSITEUSERLOCATION;

  constructor(public companyId: string, public siteId: string) { }
}

export class AddCompanySiteUserLocationSuccess implements Action {
  readonly type = ActionType.ADD_COMPANYSITEUSERLOCATION_SUCCESS;
  constructor() { }
}

export class AddCompanySiteUserLocationFailed implements Action {
  readonly type = ActionType.ADD_COMPANYSITEUSERLOCATION_FAILED;
  constructor() { }
}

export class AddCompanyUserLocation implements Action {
  readonly type = ActionType.ADD_COMPANYUSERLOCATION;

  constructor(public companyId: string) { }
}

export class AddCompanyUserLocationSuccess implements Action {
  readonly type = ActionType.ADD_COMPANYUSERLOCATION_SUCCESS;
  constructor() { }
}

export class AddCompanyUserLocationFailed implements Action {
  readonly type = ActionType.ADD_COMPANYUSERLOCATION_FAILED;
  constructor() { }
}

export class AddSiteUserLocation implements Action {
  readonly type = ActionType.ADD_SITEUSERLOCATION;

  constructor(public siteId: string) { }
}

export class AddSiteUserLocationSuccess implements Action {
  readonly type = ActionType.ADD_SITEUSERLOCATION_SUCCESS;
  constructor() { }
}

export class AddSiteUserLocationFailed implements Action {
  readonly type = ActionType.ADD_SITEUSERLOCATION_FAILED;
  constructor() { }
}

export class AddCompanySiteCategoryProductGroupProduct implements Action {
  readonly type = ActionType.ADD_COMPANYSITECATEGORYPRODUCTGROUPPRODUCT;

  constructor(
    public companyId: string,
    public siteId: string,
    public categoryId: string,
    public productGroupId: string,
    public productId: string) {}


}

export class AddCompanySiteCategoryProductGroupProductSuccess implements Action {
  readonly type = ActionType.ADD_COMPANYSITECATEGORYPRODUCTGROUPPRODUCT_SUCCESS;
  constructor() { }
}

export class AddCompanySiteCategoryProductGroupProductFailed implements Action {
  readonly type = ActionType.ADD_COMPANYSITECATEGORYPRODUCTGROUPPRODUCT_FAILED;
  constructor() { }
}

export type CompanySiteUserLocationActions =
  AddCompanySiteUserLocation | AddCompanySiteUserLocationSuccess | AddCompanySiteUserLocationFailed |
  AddCompanyUserLocation | AddCompanyUserLocationSuccess | AddCompanyUserLocationFailed |
  AddSiteUserLocation | AddSiteUserLocationSuccess | AddSiteUserLocationFailed |
  AddCompanySiteCategoryProductGroupProduct | AddCompanySiteCategoryProductGroupProductSuccess | AddCompanySiteCategoryProductGroupProductFailed |
  AddSiteUser | AddSiteUserSuccess |  AddSiteUserFailed |
  AddSiteUserHotelRoomNumber | AddSiteUserHotelRoomNumberSuccess | AddSiteUserHotelRoomNumberFailed

  ;


